import { Briefcase, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/launchx/Reveal";
import { agencyWa } from "./AgencyLayout";

export const AgencyPortfolio = ({ content, scrollTo }) => {
  const items = content?.portfolio || [];

  return (
    <section id="portfolio" data-testid="agency-portfolio" className="bg-navy py-20 sm:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(34,211,238,0.07),transparent_50%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyanx">Our Work</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Concepts and client work
          </h2>
          <p className="mt-4 text-base text-slate-400 max-w-2xl leading-relaxed">
            A look at the kind of presence we build. Demonstration concepts are clearly marked — real client results are added with permission.
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {items.map((item, i) => (
            <Reveal key={item.id || i} delay={i * 0.08}>
              <div data-testid={`agency-portfolio-card-${item.id || i}`} className="h-full bg-navy-800/60 border border-white/8 rounded-3xl overflow-hidden hover:border-cyanx/30 transition-all duration-300 hover:-translate-y-1">
                {item.image_url ? (
                  <img src={item.image_url} alt={item.title} className="w-full h-52 object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-52 bg-gradient-to-br from-electric/25 via-navy-700 to-navy-800 flex items-center justify-center">
                    <Briefcase size={40} className="text-cyanx/50" />
                  </div>
                )}
                <div className="p-7">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[10px] font-bold uppercase tracking-[0.15em] bg-electric/20 text-cyanx rounded-full px-3 py-1">{item.industry}</span>
                    {item.demo && <span className="text-[10px] font-bold uppercase tracking-[0.15em] bg-white/10 text-slate-300 rounded-full px-3 py-1">Demo Concept</span>}
                  </div>
                  <h3 className="mt-4 font-display text-lg font-semibold text-white">{item.title}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{item.description}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {(item.services || []).map((s) => (
                      <span key={s} className="text-[11px] font-medium text-slate-300 border border-white/10 rounded-full px-3 py-1">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-5 bg-navy-800/60 border border-white/8 rounded-3xl p-7 sm:p-8">
            <p className="text-sm text-slate-300 max-w-xl">
              <span className="font-semibold text-white">Want results like these for your business?</span> Start with a free audit — we'll show you exactly what's holding you back online.
            </p>
            <button data-testid="agency-portfolio-cta" onClick={() => scrollTo("audit")} className="shrink-0 inline-flex items-center gap-2 bg-electric hover:bg-electric-dark text-white text-sm font-semibold rounded-full px-6 py-3.5 transition-all hover:shadow-lg hover:shadow-electric/40">
              Get Free Audit <ArrowRight size={15} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
